import { commonTypes } from '../common';

export const initialState = {
};

const ApisNeedsMobileInsuranceReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.MOBILE_INSURANCE: {
      const { payload } = action;
      const { insurance } = payload;
      const { name, modality } = insurance;

      return {
        ...state,
        deviceInfo: {
          ...state.deviceInfo,
          mobileInsurance: {
            ...state.deviceInfo.mobileInsurance,
            name,
            modality,
          },
        },
      };
    }
    default:
      return null;
  }
};

export const actions = {

};

export default ApisNeedsMobileInsuranceReducer;
